import { fetchActiveRequests } from "~/util/providers/review";
import { IEventsListResponse } from "~/activerequest/interfaces";
import ContentOverlay from "~/content.overlay";
import { _ } from "~/i18n";
import { icon, node } from "~/util/dom";

async function sendAnalytics() {
	try {
		const response = await fetchActiveRequests();
		const result = await response.json() as IEventsListResponse;
		const allEls = Array.from(document.querySelectorAll(`*[data-dot="item-promo.mapy"]`));
		const allMatches: Array<{
			type: string;
			id: number;
		}> = [];

		allEls.forEach(el => {
			const link = el.querySelector("a").href;
			const match = link.match(/([d]*rrid)=(\d+)/u);

			match && allMatches.push({
				type: match[1],
				id: parseInt(match[2]),
			});
		});

		result.events.forEach(event => {
			const found = allMatches.find(match => match.id === event.id);

			if (!found) {
				return;
			}

			const poiData = event?.data?.poi?.poiagg || { typeId: 0, id: 0 };

			Mapy.getComponent("logger").log("notification_impress", {
				type: found.type === "drrid" ? "updateReviews" : "suggestionReviews",
				section: "accounts",
				signal: `${poiData.typeId}_${poiData.id}`,
			});
		});
	} catch (exc) {
		// eslint-disable-next-line no-console
		console.log(exc);
	}
}

export default class NotificationList extends ContentOverlay {
	_state: any;

	constructor() {
		super();

		this._state = {};

		this._contentName = "notifications-list";
		this._dom = {
			container: node("div", { id: "notification-list" }),
			exitButton: node("button", { type: "button", className: "exit-button" }),
		};
		this._dom.exitButton.addEventListener("click", this._clickClose.bind(this), false);
		this._dom.exitButton.setAttribute("aria-label", _("back"));
		this._dom.exitButton.appendChild(icon("close-thin"));

		// tohle brani chybam, ale je jinak na nic
		this._buildCloseButton();
	}

	activate() {
		if (this.isActive()) {
			return this;
		}

		this._dom.container.appendChild(this._dom.exitButton);

		return super.activate();
	}

	deactivate() {
		if (!this.isActive()) {
			return this;
		}

		this._state.stack.visible = false;

		return super.deactivate();
	}

	setState(state) {
		const stack = state.stack;

		if (stack._options.icon === "bell") {
			sendAnalytics();
		}

		this._state = state;
		stack.visible = true;
		this._dom.container.appendChild(stack.node);
	}
}
